import { UntypedFormControl } from '@angular/forms';

import { isEmpty } from '@recruitee/utils';

// based on https://gist.github.com/dperini/729294
// prettier-ignore
export const URL_PATTERN = new RegExp(
  '^' +
    // protocol identifier (optional)
    // short syntax // still required
    '(?:(?:(?:https?):)?\\/\\/)' +
    '(?:www\.|(?!www))' +
    '(?:' +
      // host & domain names, may end with dot
      '(?:' +
        '(?:' +
          '[a-z0-9\\u00a1-\\uffff]' +
          '[a-z0-9\\u00a1-\\uffff_-]{0,62}' +
        ')?' +
        '[a-z0-9\\u00a1-\\uffff]\\.' +
      ')+' +
      // TLD identifier name, may end with dot
      '(?:[a-z\\u00a1-\\uffff]{2,}\\.?)' +
      ')' +
      // port number (optional)
      '(?::\\d{2,5})?' +
      // resource path (optional)
      '(?:[/?#]\\S*)?' +
    '$', 'i'
);
export function urlValidator(control: UntypedFormControl): { url: true } | null {
  return isEmpty(control.value) || URL_PATTERN.test(control.value) ? null : { url: true };
}
